'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';

const renderSection = content => {
  if (!content) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "align-center",
    children: content
  });
};

export default function Bar(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "m-all-4 flex-row justify-between flex-no-wrap",
    children: [renderSection(props.left), renderSection(props.right)]
  });
}
Bar.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node
};